export default {
    values: Object.freeze ({
        T: Symbol(1),
        CHAMBER: Symbol(2),
    }),
    labels: {
        1: 'T',
        2: 'chambre(s)',
    }
}
